theme.AssetsLoader.onPageLoaded(function () {
  $('body').on('click', '.content-edu-download-login', function(event) {
    if (!theme.customer) {
      openLoginRegisterModal();
    }
  })

  $('body').on('click', '.download-track', function(event) {
    if (theme.customer && window.dataLayer && makeblock.customer) {
      const start_time = __Xtool_Utils.dateFormat(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      if (window.SenseBlock) {
        window.SenseBlock.gtmTrack('download_class', {
          event: 'download_class',
          email: __MakeBlock_Utils.encode(makeblock.customer.email),
          start_time,
          is_success: true,
          class_name: $(this).attr('data-js-title')
        })
      }
    }
  })

  function openLoginRegisterModal() {
    let loginRegisterModal;
    if ($('mkt-login-register-modal').length) {
      loginRegisterModal = $('mkt-login-register-modal').get(0);
      $(loginRegisterModal).attr('visible', true);
    } else {
      const createdLoginRegisterModal = $('<mkt-login-register-modal>');
      loginRegisterModal = $(createdLoginRegisterModal).get(0);
      $(loginRegisterModal)
        .attr('close-icon', true)
        .attr('mask', true)
        .attr('mask-closable', true)
        .attr('visible', true)
        .attr('source','class_page')
        .attr('register-customer-tag', 'edu-user');

      $('body').append(loginRegisterModal);
    }

    loginRegisterModal.addEventListener('close', function() {
      console.log('---loginRegisterModal---close!!!!!')
      loginRegisterModal.removeAttribute('visible');
    })

    loginRegisterModal.addEventListener('submit', function() {
      window.location.reload()
    })
  }
})